import { FC, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { getChallenge } from 'src/redux-api-bridge/challenge/selectors'
import { WiredChallengePanel } from 'src/pages/orders/components/WiredChallengePanel'
import { CHALLENGE_IDS } from 'src/constants/challenge'
import {
  fetchUserChallenges,
  fetchChallengeWithSteps
} from 'src/redux-api-bridge/challenge/effects'

const Global: FC = () => {
  const dispatch = useDispatch()
  const { active } = useSelector(getChallenge)

  useEffect(() => {
    dispatch(fetchUserChallenges())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    active.forEach(({ challengeId, enabled, variant }) => {
      if (challengeId && enabled && variant === 'treatment-1') {
        dispatch(fetchChallengeWithSteps(challengeId))
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active])

  return (
    <>
      {active.some(
        challenge => challenge.challengeId === CHALLENGE_IDS.FIVE_MILESTONES
      ) && <WiredChallengePanel challengeId={CHALLENGE_IDS.FIVE_MILESTONES} />}
    </>
  )
}

export default Global
